module.exports = __webpack_public_path__ + "static/media/3-min.9bbb6990.png";